module.exports = require("core-js/library/fn/weak-map");